export default __webpack_public_path__ + "static/media/prototypes-that-interact.0cc7057f.svg";